export default {
      id: "warning-24-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "assets/iconset.svg#warning-24",
      toString: function () {
        return this.url;
      }
    }